export class SoftDeletedError extends Error {
  isSoftDeleted: boolean

  constructor(message: string) {
    super(message)
    this.name = 'SoftDeletedError'
    this.isSoftDeleted = true
  }
}
